import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, CustomEase);
gsap.defaults({ ease: "none" });

window.addEventListener(
  "load",
  function () {
    if (document.body.classList.contains("page-template-page-billing")) {
      const animationGroups = this.document.querySelectorAll(".line-animation");

      animationGroups.forEach((animationGroup) => {
        gsap.set(animationGroup.querySelector(".line-dot.start"), { scale: 1 });
        gsap.set(animationGroup.querySelector(".line-dot.end"), {
          scale: 1,
          fill: "#fff",
        });

        const line = gsap
          .timeline({
            defaults: { duration: 1 },
            scrollTrigger: {
              trigger: animationGroup,
              scrub: true,
              start: "top 75%",
              end: "bottom 50%",
            },
          })
          .fromTo(
            animationGroup.querySelector(".progress"),
            { drawSVG: "0% 0%" },
            { drawSVG: "0% 100%" },
            0,
          )
          .to(
            animationGroup.querySelector(".line-dot.end"),
            { fill: "#FFB88C", duration: 0.01 },
            0.99,
          );
      });
    }
  },
  false,
);
